import {get, writable} from "svelte/store";
import {cargaUno, actualiza, crea} from "../Api/motivos";

const estadoInicial = {
  cargando: true,
  error: null,
  motivo: null
};

const store = writable(estadoInicial);

export default {
  subscribe: store.subscribe,
  cargar: (id) => {
    const timeout = setTimeout(() => store.update(valor => ({...valor, cargando: true})), 300);

    store.update(() => estadoInicial);

    cargaUno(id)
        .then(motivo => store.update(valor => ({...valor, motivo})))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => {
          clearTimeout(timeout);
          store.update(valor => ({...valor, cargando: false}));
        });
  },
  actualizaCampo: (campo, valor) => {
    store.update(estado => ({
      ...estado,
      motivo: {...estado.motivo, [campo]: valor}
    }));
  },
  nuevo: () => {
    store.set({
      cargando: false,
      error: null,
      motivo: {
        nombre: '',
        tipo: 'Ausencia',
        automatico: false
      }
    });
  },
  guarda: () => {
    const motivo = get(store).motivo;

    const promesa = motivo.id ? actualiza(motivo) : crea(motivo);
    return promesa
        .then(motivo => store.update(valor => ({...valor, error: false, motivo})))
        .catch(error => store.update(valor => ({...valor, error})));
  }
}